import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from "@angular/forms";


@Directive({
    selector: "[validateDate]",
    providers: [{ provide: NG_VALIDATORS, useExisting: DateValidatorDirective, multi: true }]
})
export class DateValidatorDirective implements Validator {
    @Input() regex: string;
    @Input() set validateDate(value) {
        if (value) {
            this._validateDate = value;
        }
    }
    private _validateDate = 'datetime';
    private dateTimeRegex = /\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]) (0[0-9]|1[0-9]|2[0-4]):(0[0-9]|[0-5][0-9]):(0[1-9]|[0-5][0-9])/;
    private dateRegex = /(\d{4})-(\d{2})-(\d{2})/;

    validate(c: AbstractControl): { [key: string]: any } {
        let value = c.value;
        return this.validateDateRegex(value) ? null : { match: true };
    }

    validateDateRegex(value) {
        if (!value) {
            return true;
        } else if (this.regex) {
            return value.match(this.regex);
        } else if (this._validateDate === 'datetime') {
            return value.match(this.dateTimeRegex);
        } else if (this._validateDate === 'date') {
            return value.match(this.dateRegex);
        }
    }

}
